<arrays-list-table
    [items]="filteredArrays"
    [mode]="mode"
    [alertMap]="alertMap"
    [allOrders]="allOrders"
    [showWarningCardForOutOfSupportAppliance]="showWarningCardForOutOfSupportAppliance"
>
</arrays-list-table>
